var React = require('react');
var FuzzyReaction = require('../../bootstrap').FuzzyReaction;
var Fz = FuzzyReaction.require('components', 'Modal', 'Row', 'Column');

class UploadProgressModal extends React.Component {
    render() {
		return (
			<div className="upload-progress">
				<div className="progress-bar progress-bar-striped cast-details-upload-progress">
					<div className="progress-bar" style={{width: this.props.progressWidth}}></div>
				</div>
					{this.props.progressWidth === '100%' && (
						<Fz.Row>
							<Fz.Column grid="lg" size="10" classes="offset-lg-1">
								<h4>{this.props.successText}</h4>
							</Fz.Column>
						</Fz.Row>
					)}
			</div>
		)
	}
}

module.exports = UploadProgressModal;
